import { OnderwijsLocatie } from '@models/onderwijs-locatie.model';

 
export namespace OnderwijslocatiesActions {
  export class LoadOnderwijslocaties {
    static readonly type = '[Onderwijslocaties] Load onderwijslocaties';
  }

  export class SelectOnderwijslocatie {
    static readonly type = '[Onderwijslocatie] selected onderwijslocatie';
    constructor(public payload: OnderwijsLocatie) {}
  }
}
